import { BaseSelectHTMLHTMLElement } from "components/input/select/baseSelectHTMLElement";
import { Tooltip } from "components/components/tooltip/tooltip";
import { Optgroup, Option } from "components/input/select/options";
import { OptionIterator } from "components/input/select/OptionIterator";
import $ from "jquery";
import template from "components/input/select/selectElement.hbs";
import optionsTemplate from "components/input/select/options.hbs";

export class SelectInputElement extends BaseSelectHTMLHTMLElement {

    constructor() {
        super();

        this.codeInOptionLabel = (this.getAttribute("codeInOptionLabel") === "true");

        const optTemplate = {
            "prefixId": "si",
            "id": this.getAttribute("_id"),
            "className": "c-select-input__input o-form-component__input o-form-component__input-group__input",
            "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
            "style": this.getAttribute("_style"),
        } as any;

        this.innerHTML = template(optTemplate);

        this.input = this.querySelector("select");

        this.bindEvents();
        Tooltip.bindElement(this);
    }

    public set data(v: string | number) {
        $(this.input).val(v);
        this.initialValue.value = this.data;
    }

    public get data(): string | number {
        if (this.options == null || this.options.length === 0) {
            return null;
        }
        let idx = this.input.selectedIndex;
        let allOptions = OptionIterator.filterFlat(
            this.options,
            () => true);
        if (idx !== -1) {
            return allOptions[idx].value?.toString() ?? null;
        }
        return null;
    }

    public addOptions(options: Array<Option | Optgroup>): void {
        if (options == null) {
            return;
        }
        if (this.options == null) {
            this.options = [];
        }
        this.options = this.options.concat(options);
        let templated = $(optionsTemplate({ options, codeInOptionLabel: this.codeInOptionLabel }));
        templated.appendTo(this.input as JQuery<HTMLElement>);
    }

    public disableOptions(options: Array<string | number>): boolean {
        let fireDataChanged: boolean = false;
        if (options.includes(this.data)) {
            this.data = "";
            //Lanzar evento pq se borra el seleccionado
            fireDataChanged = true;
        }
        this.enableDisableOptions(options, true);
        return fireDataChanged;
    }
}

export function initSelectInputWebComponent() {
    window.customElements.define("s6-select-input", SelectInputElement);
}
